<template>
    <wire-frame-gdb>
        <template v-slot:top-main-legend><span></span></template>
    </wire-frame-gdb>
</template>
<script>
export default {
}
</script>